import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  ReportSupplierPaidInvoices
} from "@/components/finance/reporting";
import {
  BoxedContent, Header, SvgIcon, IconButton, HeaderLeftContent
} from "@/components/common";
import { selectActiveCompany } from "@/store/appSlice";
import appSettings from "@/settings";

function ReportSupplierPaidInvoicesWrapper() {
  const { id } = useParams();
  const activeCompany = useSelector(selectActiveCompany);
  const exportExcel = () => window.open(`${appSettings.baseUrl}/procurement/reports/supplier/${id}/paid/xls?companyId=${activeCompany.id}`, "_blank", "noopener,noreferrer");

  return (
    <BoxedContent>
      <Header
        showBreadcrumb
        leftContent={<HeaderLeftContent title="Supplier Paid Invoices" subtitle="" icon="file-check-stroke-icon" />}
        rightContent={(
          <div>
            <IconButton
              className="icon-button-with-text"
              onClick={() => exportExcel(id)}
            >
              <SvgIcon icon="excel" />
              <span>Download Excel</span>
            </IconButton>
          </div>
        )}
      />
      <ReportSupplierPaidInvoices id={id} />
    </BoxedContent>
  );
}

export default ReportSupplierPaidInvoicesWrapper;
